import { api } from '../../index';
import {
  CreateShareBody,
  SharedCalendar,
  SharedTimesheetInfo,
  SharedTimesheets,
  TimesheetShare,
} from './types';

const resourceUrl = '/timesheets/shares';

/** Requests below are read by link holders who are not logged in, so they carry no token. */
const PUBLIC_REQUEST = { withoutAT: true };

export const createShareLink = (body: CreateShareBody) => api.post<TimesheetShare>(`${resourceUrl}/`, {
  year: body.year,
  month: body.month,
  period: body.period,
  ...(body.userId ? { user_id: body.userId } : {}),
});

export const revokeShareLink = (token: string) => api.delete(`${resourceUrl}/${token}/`);

export const getSharedTimesheetInfo = (token: string) => (
  api.get<SharedTimesheetInfo>(`${resourceUrl}/${token}/`, {}, PUBLIC_REQUEST)
);

export const getSharedCalendar = (token: string) => (
  api.get<SharedCalendar>(`${resourceUrl}/${token}/calendar/`, {}, PUBLIC_REQUEST)
);

export const getSharedTimesheets = (token: string) => (
  api.get<SharedTimesheets>(`${resourceUrl}/${token}/timesheets/`, {}, PUBLIC_REQUEST)
);
